
<div class="row">
  <div class="col-lg-12 input-control" style="justify-content:flex-start">
    <div class="row margin-top-16">

      <div class="col-lg-12" style="display: flex; justify-content: end;">
        <hub-button *ngIf="addManually" [icon]="'plus-alt'" [size]="'xl'" [style]="'outline'" [text]="'customer.addresses.add_new' | translate" (buttonClick)="addManually = !addManually; showAddressForm = false;"></hub-button>
        <br />
      </div>

      <div class="col-lg-12" *ngIf="!addManually" style="margin-left: 0px; padding-right: 12px;">

        <div class="input-control" *ngIf="!addManually" style="margin-bottom: 8px;">
          <hub-autocomplete [(ngModel)]="customer.Address" [suggestions]="addressOptions" class="hub-input"
                            (completeMethod)="search($event)"
                            (onSelect)="onSelect($event)" field="address"
                            label="{{'customer.addresses.search' | translate}}"></hub-autocomplete>
        </div>
        <hub-button [icon]="'plus-alt'" [size]="'sm'" [style]="'outline'" [text]="'customer.addresses.add_manually' | translate" (buttonClick)="showAddressForm = !showAddressForm"></hub-button>
        <br />
      </div>
      <div class="row" *ngIf="showAddressForm" style="margin-left: 0px; padding-right: 12px;">
        <div class="col-lg-2 input-control small-bottom" style="flex-direction:column-reverse;">
          <hub-input [(ngModel)]="street_no" label="{{'customer.addresses.street_number' | translate}}"></hub-input>
        </div>
        <div class="col-lg-10 input-control small-bottom">
          <hub-input [(ngModel)]="street_address" [required]="true" label="{{'customer.addresses.street_name' | translate}}"></hub-input>
        </div>
        <div class="col-lg-12 input-control small-bottom">
          <hub-input [(ngModel)]="apartment" label="{{'customer.addresses.apartment_building' | translate}}"></hub-input>
        </div>
        <div class="col-lg-12 input-control small-bottom">
          <hub-input [(ngModel)]="city" [required]="true" label="{{'customer.addresses.city' | translate}}"></hub-input>
        </div>
        <div class="col-lg-12 input-control small-bottom" style="flex-direction:column-reverse;">
          <hub-input [(ngModel)]="postal_code" label="{{'customer.addresses.postal_code' | translate}}"></hub-input>
        </div>
        <div class="col-lg-12 input-control small-bottom">
          <hub-input [(ngModel)]="country" label="{{'customer.addresses.country' | translate}}"></hub-input>
        </div>
        <div class="col-lg-12 input-control small-bottom">
          <hub-input [(ngModel)]="customer.AddressType" [maxLength]="32" label="{{'customer.addresses.label' | translate}}"
                     [required]="true"></hub-input>
          <div class="error-message" *ngIf="validateManualAddress() && this.customer.AddressType.trim().length > 0">{{ errorLabel }}</div>
        </div>
        <div class="col-lg-12" style="text-align: -webkit-right;">
          <hub-button *ngIf="!editing" [icon]="'enter'" [size]="'xl'" [style]="'outline'" [text]="'bikeshop.shop_profile.collections.buttons.add' | translate" (buttonClick)="addAddressManually()" [disabled]="validateManualAddress()"></hub-button>
          <hub-button *ngIf="editing" [icon]="'enter'" [size]="'xl'" [style]="'outline'" [text]="'bikeshop.general.save' | translate" (buttonClick)="editAddress()" [disabled]="validateManualAddress()"></hub-button>
          <br />
        </div>
      </div>
    </div>
  </div>


  <div class="col-lg-12 input-control" style="justify-content: flex-start;" *ngIf="addresses.length > 0 && addManually">
    <div class="row address-container">
      <div *ngFor="let address of addresses; index as i;" class="col-lg-6">
        <div class="card">
          <div class="info">
            <div  style="min-height:150px">
              <div class="row">
                <div class="col-md-8 wrapped-center">
                  <div class=""><h2 class="title">{{address.name}}</h2></div>
                </div>
                <div class="col-md-4 title" style="display: flex; justify-content: flex-end; align-items: center;">
                  <hub-button-icon-only [icon]="'pencil'" (click)="editAddresses(address)"></hub-button-icon-only>
                  <hub-button-icon-only [icon]="'trash'" (click)="deleteAddresses(address)"></hub-button-icon-only>
                </div>
              </div>
              <p class="desc">{{address.street_no}} {{address.street_address}}</p>
              <p class="desc">{{address.apartment}}</p>
              <p class="desc">{{address.city}}, {{address.postal_code}}</p>
              <p class="desc">{{address.country}}</p>
            </div>
            <div class="meta" style="min-height:40px">
              <div class="stock">
                <div class="row">
                  <div class="col-md-10 wrapped-center">
                    <p class="desc" style="margin: 5px 0px 2px 0px;">{{ 'customer.addresses.set_as_default' | translate }}</p>                    
                  </div>
                  <div class="col-md-2">
                    <p-inputSwitch [disabled]="address.isDefault" [(ngModel)]="address.isDefault" (onChange)="defaultChanged(address, i, $event)"></p-inputSwitch>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="col-lg-12 input-control" style="justify-content: center;" *ngIf="addresses.length == 0 && addManually && !loading">
    <div class="row">
      <div class="p-6 flex placeholder">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin h-10 w-10 opacity-40"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
        <p class="text-sm font-medium">{{ 'customer.addresses.no_address' | translate}}</p>
        <p class="text-xs">{{ 'customer.addresses.add_to_start' | translate}}</p>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog key="pos_confirmation"></p-confirmDialog>

